import React from 'react';
import { CircularProgress } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import PopupBase from '../../../../../popup/base/PopupBase';
import CustomButton from '../../../../../components/buttons/CustomButton';
import styles from './RoomDeletePopup.module.css';

/** Confirma a exclusão definitiva da sala e lembra que inativar é a saída sem perda. */
function RoomDeletePopup({ room, saving, onConfirm, onClose }) {
    const content = (
        <div className={styles.content}>
            <p className={styles.question}>
                Tem certeza que deseja excluir a sala <strong>"{room.name}"</strong>?
            </p>
            <div className={styles.warning}>
                <WarningAmberRoundedIcon className={styles.warningIcon} />
                <span>
                    Esta ação não pode ser desfeita. Os agendamentos desta sala, passados e futuros, ficarão sem sala. Para só tirar a sala de uso, inative-a.
                </span>
            </div>
        </div>
    );

    const footer = (
        <div className={styles.footer}>
            <CustomButton style="primary" variant="text" label="Cancelar" onClick={onClose} enabled={!saving} />
            <CustomButton
                style="error"
                variant="contained"
                label="Excluir sala"
                icon={saving ? <CircularProgress size={16} color="inherit" /> : <DeleteOutlinedIcon />}
                onClick={onConfirm}
                enabled={!saving}
            />
        </div>
    );

    return (
        <PopupBase Title="Excluir sala" Content={content} Footer={footer} OnClose={onClose} maxWidth="xs" />
    );
}

export default RoomDeletePopup;
